import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';
import { login, verify2fa } from 'src/common/index';
import { getOwnAccount } from 'src/selectors/accounts';
import LoginForm from 'src/components/account/login-form';
import { fetchOwnAccount } from 'src/actions/accounts';
import logoRound from 'static/Busfinder_Kreis_100.png';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { withTranslation } from 'react-i18next';
import LoginForm2FA from 'src/components/account/login-form-2fa';
import { safeGetStorageItem, safeRemoveStorageItem, STORAGE_KEYS } from 'src/utils/storage';

class Login extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            is2faRequired: false,
        };
    }

    componentDidMount() {
        this.redirectIfLoggedIn(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.redirectIfLoggedIn(nextProps);
    }

    redirectIfLoggedIn(props) {
        const { ownAccount, push } = props;
        const loggedIn = ownAccount && ownAccount.entity && !ownAccount.isFetching;

        // redirect after successful login, or when already logged in
        if (loggedIn) {
            const redirectUrl = safeGetStorageItem(STORAGE_KEYS.REDIRECT_URL_AFTER_LOGIN, 'session');
            if (redirectUrl) push(redirectUrl);
            else push('/');
            safeRemoveStorageItem(STORAGE_KEYS.REDIRECT_URL_AFTER_LOGIN, 'session');
        }
    }

    handleSubmit(data) {
        this.props.login(data.username, data.password, fetchOwnAccount, undefined, true, this.setIs2FaRequired);
    }

    setIs2FaRequired() {
        this.setState({ is2faRequired: true });
    }

    handleSubmit2Fa(data) {
        this.props.verify2fa(data.code, fetchOwnAccount, undefined);
    }

    render() {
        const { t } = this.props;
        const query = this.props.location.query;
        const hasError = query && query.error;
        const hasExpired = query && query.expired;
        const hasLogout = query && query.logout;
        const params = new URLSearchParams(this.props.location.search);
        let devLoginSelection = null;
        if (window.location.hostname === 'localhost' && Array.isArray(Config.ACCOUNTS)) {
            const accountMenuItems = Config.ACCOUNTS.map(account => {
                return <MenuItem key={account.username} value={account} primaryText={account.username} />;
            });

            devLoginSelection = (
                <SelectField
                    floatingLabelStyle={{ top: 28 }}
                    menuStyle={{ marginTop: 5, width: '400px' }}
                    underlineStyle={{ display: 'none' }}
                    onChange={(event, index, account) => {
                        this.props.login(
                            account.username,
                            account.password.padEnd(8, '#'),
                            fetchOwnAccount,
                            undefined,
                            true,
                            this.setIs2FaRequired,
                        );
                    }}
                    floatingLabelText={t('click_here_account')}
                    fullWidth={true}>
                    {accountMenuItems}
                </SelectField>
            );
        }

        return (
            <div className="background-image">
                <div id="login-div-outer">
                    <div id="login-form">
                        <div id="login-form-logo">
                            <img width="100px" src={logoRound} />
                        </div>
                        {!this.state.is2faRequired && (
                            <LoginForm
                                onSubmit={this.handleSubmit}
                                hasError={hasError}
                                hasExpired={hasExpired}
                                hasLogout={hasLogout}
                                devLoginSelection={devLoginSelection}
                            />
                        )}
                        {this.state.is2faRequired && (
                            <LoginForm2FA
                                onSubmit={this.handleSubmit2Fa}
                                hasError={hasError}
                                hasExpired={hasExpired}
                                hasLogout={hasLogout}
                                devLoginSelection={devLoginSelection}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ownAccount: getOwnAccount(state),
    };
};

export default withTranslation()(connect(mapStateToProps, { login, verify2fa, push })(Login));

export const isLoggedIn = account => {
    return account && !account.isFetching && account.entity;
};

export const isLoggedInWithRole = (account, roles) => {
    return isLoggedIn(account) && _.includes(roles, account.entity.role);
};
